enum EElement {
  accountHeader = 'account-header',
  accountSideNav = 'account-side-nav',
  appHeader = 'app-header',
  appFooter = 'app-footer',
  chatbotFooter = 'chatbot-footer',
  chatbotHeader = 'chatbot-header',
  chatbotMessageTextfield = 'chatbot-message-textfield',
  tryItOutHeader = 'try-it-out-header',
  fastSetupHeader = 'fast-setup-header',
}

export default EElement

export type Keys<T> = { [K in keyof T]: K }
